// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import product from "assets/images/product1.png";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import add from "assets/images/add.png";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDiscountListingsMutation } from "services/discount";
import { useDeleteDiscountMutation } from "services/discount";
import ShowToast from "components/MDToast";
import MDAvatar from "components/MDAvatar";
import WarnModal from "components/DeleteModal";
import { Box, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import Pagination from "components/Pagination";
import Loader from "helpers/constants/Loader";
import { useGetCouponMutation } from "services/coupon";
import { useDeleteCouponMutation } from "services/coupon";
import useTranslation from "hooks/Translation";

const ManageDiscount = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const [deleteOrder] = useDeleteCouponMutation();
  const [selectedId, setSelected] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [loading, setLoading] = useState(false);

  const handleDeleteOrder = async (id) => {
    try {
      const response = await deleteOrder({ id: id }).unwrap();
      if (response?.status === 200) {
        ShowToast("Discount deleted successfully", "success");
        fetchDiscountListingApi();
        setDeleteModalOpen(false);
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const Author = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <img
        src={image}
        alt="banner"
        style={{ width: 40, height: 40, borderRadius: "50%" }}
      />
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const Discount = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left" sx={{ minWidth: 120 }}>
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const [discountListing, setDiscountListing] = useState([]);
  const [discountListingApi] = useGetCouponMutation();

  const fetchDiscountListingApi = async () => {
    let body = {
      start: 1,
      length: 10,
      search: "",
    };
    setLoading(true);
    try {
      const response = await discountListingApi(body).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setDiscountListing(response?.data?.response_object || []);
        setTotalRecords(response?.data?.count);
      } else {
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(totalRecords / limit);

  const columns = [
    { Header: t.main.discountName, accessor: "price", align: "left" },
    { Header: t.main.percentage, accessor: "status", align: "left" },

    { Header: t.main.description, accessor: "stock", align: "left" },
    { Header: t.main.startDate, accessor: "start", align: "center" },
    { Header: t.main.endDate, accessor: "end", align: "center" },
    { Header: t.main.actions, accessor: "action", align: "center" },
  ];

  const rows = discountListing?.map((item) => ({
    price: <Discount title={item?.discount_name_en} />, // Display discount percentage
    status: (
      <Job
        title={
          item.discount_percentage ? `${item.discount_percentage}%` : "N/A"
        }
      />
    ), // Display discount percentage or "N/A"
    stock: <Job title={item?.description_en || "-"} />, // Adjust if stock information is available
    start: <Job title={new Date(item.start_date).toLocaleDateString()} />, // Format the start date
    end: <Job title={new Date(item.end_date).toLocaleDateString()} />, // Format the end date
    action: (
      <Box className="table_actions">
        <IconButton
          size="small"
          onClick={() => navigate(`/manage-discount/details/${item?.id}`)}
        >
          <VisibilityIcon />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => navigate(`/manage-discount/edit/${item?.id}`)}
        >
          <ModeEditIcon />
        </IconButton>

        <IconButton
          size="small"
          onClick={() => {
            setDeleteModalOpen(true);
            setSelected(item?.id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    ),
  }));

  useEffect(() => {
    fetchDiscountListingApi();
  }, []);

  return (
    <DashboardLayout>
      <Loader loading={loading} />
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                // variant="gradient"
                bgColor="theme-1"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white">
                  {t.main.discountTable}
                </MDTypography>
                <div
                  onClick={() => navigate("/manage-discount/add")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <MDTypography
                    sx={{
                      textDecoration: "underline", // Adds an underline
                      paddingRight: 1,
                    }}
                    variant="h6"
                    color="white"
                  >
                    {t.main.addDiscount}
                  </MDTypography>
                  <img src={add} style={{ width: 20, height: 20 }} />
                </div>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
              {discountListing.length > 0 && (
                <MDBox p={2}>
                  <Pagination
                    setPage={setPage}
                    module={discountListing}
                    page={page}
                    onPageChange={setPage}
                    totalPages={totalPages}
                    limit={limit}
                    setLimit={setLimit}
                  />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <WarnModal
        open={deleteModalOpen}
        setOpen={setDeleteModalOpen}
        handleDelete={() => handleDeleteOrder(selectedId)}
        name="Discount"
      />
      <Footer />
    </DashboardLayout>
  );
};

export default ManageDiscount;
